import React from 'react';

const LoadingDataDiv = () => {
  return (
    <div className="spinner-border text-secondary" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingDataDiv;
